import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  title: {
    margin: theme.spacing(0, 2),
  },
  btnPages: {
    marginTop: theme.spacing(3),
    justifyContent: 'flex-end',
  },
}));
